import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

// const purchaseInvoiceURL = `api/v1/purchase-app/purchase-invoice/branch`;
const purchaseInvoiceURL = `api/v1/purchase-app/purchase-invoice`;
//

//obtaining the paginated data
export const getPurchaseInvoice = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseInvoiceURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseInvoice = () => axiosInstance.get(`${purchaseInvoiceURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseInvoice = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseInvoiceURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );
// get by id
export const getPurchaseInvoiceById = (id) => axiosInstance.get(`${purchaseInvoiceURL}/retrieve/${id}`);

//get purchase detail from grn
export const getPurchaseOrderDetail = (id) => axiosInstance.get(`api/v1/purchase-app/grn/retrieve/${id}`);

export const getPurchaseInvoiceAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createPurchaseInvoice = (body) =>
  axiosInstance.post(`api/v1/purchase-app/purchase-invoice/vendor/create`, body);
//updating function
export const updatePurchaseInvoice = (id, body) => axiosInstance.patch(`${purchaseInvoiceURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseInvoiceURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
